import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'equine-ui-nx-donation-subscription-state-confirmation',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule
  ],
  templateUrl: './donation-subscription-state-confirmation.component.html',
  styleUrl: './donation-subscription-state-confirmation.component.scss',
})
export class DonationSubscriptionStateConfirmationComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {label: string},
  ) {}

}
